// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"3.407.0"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import { inboundFiltersIntegration, init as initSentry, thirdPartyErrorFilterIntegration } from "@sentry/nextjs";

import { redactBreadcrumbTokens, redactEventTokens } from "@src/lib/sentry/redactLinkTokens/redactLinkTokens";

initSentry({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED === "true",
  ignoreErrors: [
    // WalletConnect timeout - expected when users don't complete wallet connection
    /Proposal expired/
  ],
  // propagate sentry-trace and baggage headers to internal API only
  // everything else will be done with custom interceptor
  tracePropagationTargets: [/^\/api\/(?!collect)/, /^\/_next\//],
  beforeBreadcrumb: redactBreadcrumbTokens,
  beforeSend: redactEventTokens,
  beforeSendTransaction: redactEventTokens,
  integrations: [
    // Filter out errors originating from browser extensions
    // Note: uses inboundFiltersIntegration (not eventFiltersIntegration) to override defaultIntegrations
    inboundFiltersIntegration({
      denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//]
    }),
    thirdPartyErrorFilterIntegration({
      filterKeys: [process.env.NEXT_PUBLIC_SENTRY_APPLICATION_KEY!],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames"
    })
  ]
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
